export function isCrsForm(formType) {
  return formType.toLowerCase().startsWith('crs');
}

export function isTranslatedForm(formType) {
  return formType.toLowerCase().startsWith('crs') || (formType.toLowerCase() === 'w8ben' || formType.toLowerCase().startsWith('w8ben_')) || formType.toLowerCase().startsWith('w9');
}

export function isTranslatedFormGroup(formGroup) {
  return formGroup.toLowerCase().startsWith('crsiw8ben');
}

export function isNoFormSupported(formType) {
  switch (formType) {
    case 'w9_2018':
    case 'w9_2024':
    case 'w8ben':
    case 'w8ben_2021':
    case 'crsi':
    case 'crsi_2024':
    case 'crse':
    case 'crscp':
    case 'fatca_crse_2023':
    case 'fatca_crsi_2023':
      return true;
    default:
      return false;
  }
}

export default isCrsForm;
